import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "copyright-area bg-white text-center py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("p", { class: "fs-14" }, [
        _createTextVNode(" © "),
        _createElementVNode("span", { class: "text-primary-div" }, "Trezo"),
        _createTextVNode(" is Proudly Owned by "),
        _createElementVNode("a", {
          href: "https://envytheme.com/",
          target: "_blank",
          class: "text-decoration-none text-primary"
        }, " EnvyTheme ")
      ])
    ], -1)
  ]))]))
}